import React, { forwardRef } from 'react';
import { Platform } from 'react-native';
import PropTypes from 'prop-types';
import Button from '@/components/Buttons/Button';

const NavigationBarButton = forwardRef(({ 
  icon,
  title,
  label,
  onPress,
  color,
  variant,
  isActive = false,
  isDanger = false,
  solidIcon = false,
  disabled = false,
  prependImage,
  prependImageSize,
  appendIcon,
  appendIconSize,
  tooltip,
  tooltipShortcut,
  ...props 
}, ref) => {
  return (
    <Button
      ref={ref}
      text={label}
      accessibilityLabel={title || label || (typeof tooltip === 'string' ? tooltip : undefined)}
      prependIcon={icon}
      appendIcon={appendIcon}
      appendIconSize={appendIconSize}
      prependImage={prependImage}
      prependImageSize={prependImageSize}
      iconIsSolid={solidIcon}
      variant={
        !!variant ? variant : 
        isActive ? 'secondary' : 
        isDanger ? 'dangerOnHover' : 'transparent'
      }
      // size={(Platform.OS === 'ios' || Platform.OS === 'android') ? 'small' : 'medium'}
      size='medium'
      isDisabled={disabled}
      onPress={onPress}
      tooltip={tooltip}
      tooltipShortcut={tooltipShortcut}
      {...props}
      style={[Platform.OS === 'macos' && !label && { width: 34, height: 34, minWidth: 34, padding: 0, borderRadius: 8 }, props.style]}
    />
  );
});

NavigationBarButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string,
  label: PropTypes.string,
  onPress: PropTypes.func,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  color: PropTypes.string,
  isActive: PropTypes.bool,
  solidIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  prependImage: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

NavigationBarButton.displayName = 'NavigationBarButton';

export default React.memo(NavigationBarButton);
